// Lazy installer for the vue2-google-maps wrapper (<GmapMap>/<gmap-autocomplete>/<GmapCluster>).
// Keeps the maps wrapper OUT of the initial/public bundle — only routes that render an interactive
// map pull it in, via the router guard in router/index.js (see MAP_ROUTE_NAMES). Idempotent: the
// dynamic import + Vue.use run at most once, no matter how many map routes are visited.
//
// NOTE: this is ONLY the Vue wrapper. The raw `google.maps` JS API (geocoder etc., used on the
// public PT detail and the DP/admin pages) is loaded separately + deferred by public/index.html and
// is unaffected by this change.
import Vue from "vue";

let installPromise = null;

export default function ensureGoogleMaps() {
  if (!installPromise) {
    installPromise = import(/* webpackChunkName: "vue-google-maps" */ "vue2-google-maps")
      .then((VueGoogleMaps) => {
        Vue.use(VueGoogleMaps, {
          load: {
            key: "AIzaSyAKeDjawjCEvrOve8mqI__tr_xA7_zN1f4",
            libraries: "places",
          },
        });
        return import(/* webpackChunkName: "vue-google-maps" */ "vue2-google-maps/dist/components/cluster");
      })
      .then((cluster) => {
        Vue.component("GmapCluster", cluster.default || cluster);
      });
  }
  return installPromise;
}
